





























































import { Component, Vue, Prop } from "vue-property-decorator";
import TeamModal from "./TeamModal.vue";
import Button from "./Button.vue";
import { Action } from "vuex-class";
import {
  USER_SEARCH,
  CREATE_TEAM,
  ADD_TEAM_MEMBER,
  DELETE_COURSE_CATEGORY,
  DELETE_PROGRAMME,
  DELETE_BATCH,
  DELETE_BATCH_USER,
  DELETE_ASSIGNEE,
} from "../store/actions.names";
import { FlatUser } from "../store/store.types";
import { namespaced, NS_ADMIN } from "../store/namespace";
@Component({
  name: "YesNoModal",
  components: {
    TeamModal,
    Button,
  },
})
export default class YesNoModal extends Vue {
  // Modal Function
  @Prop() readonly show: any;
  @Prop() readonly handleId: number;
  @Prop() readonly source: string;

  @Action(namespaced(NS_ADMIN, DELETE_BATCH)) deleteBatch: any;
  @Action(namespaced(NS_ADMIN, DELETE_BATCH_USER)) deleteBatchUser: any;
  @Action(namespaced(NS_ADMIN, DELETE_ASSIGNEE)) deleteAssignee: any;
  @Action(namespaced(NS_ADMIN, DELETE_PROGRAMME)) deleteProgramme: any;
  @Action(namespaced(NS_ADMIN, DELETE_COURSE_CATEGORY)) deleteCategory: any;

  showModal: boolean = false;
  name = "";
  close() {
    this.$emit("close");
  }
  closeModal() {
    this.close();
  }

  removeBatch() {
    const data = {
      batch_id: this.handleId,
    };
    this.deleteBatch(data).then(() => {
      this.showModal = false;
      this.close();
      this.$emit("deleteBatch");
    });
  }

  removeSingleBatchUser() {
    const data = {
      batch_id: parseInt(this.$route.params.teamId),
      user_id: this.handleId,
    };
    this.deleteBatchUser(data)
      .then((res) => {
        this.$emit("updateAssigneeList");
        //console.log("success");
      })
      .catch((e) => {
        //console.log(e);
      });
  }

  removeAssigneeUser() {
    this.deleteAssignee(this.handleId)
      .then((res) => {
        this.$emit("updateAssigneeList");
        //console.log("success");
        this.close();
      })
      .catch((e) => {
        //console.log(e);
      });
  }
  removeProgramme() {
    // this.deleteProgramme(this.handleId)
    this.deleteProgramme(this.handleId).then(() => {
      this.showModal = false;
      this.close();
      this.$emit("deleteProgramme");
    });
  }
  removeCategory() {
    this.deleteCategory(this.handleId).then(() => {
      this.showModal = false;
      this.close();
      this.$emit("deleteCategory");
    });
  }
}
